import React, { Suspense } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ConfirmProvider } from './src/components/ui/ConfirmDialog';

import DynamicEventPage from './src/pages/DynamicEventPage';
import GenericInscriptionPage from './src/pages/GenericInscriptionPage';
import MunicipalityPage from './src/pages/MunicipalityPage';
import CertificateValidationPage from './src/pages/CertificateValidationPage';
import { HomePage } from './src/pages/HomePage';
import { AdminRoutes } from './src/routes/adminRoutes';
import { OrganizerRoutes } from './src/routes/organizerRoutes';
import { PwaRoutes } from './src/routes/pwaRoutes';
import { RestrictRoutes } from './src/routes/restrictRoutes';
import { LoadingScreen } from './src/components/ui/LoadingScreen';

function InscriptionRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/inscrever-se/${slug}`} replace />;
}

function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <ConfirmProvider>
        <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/evento/:slug" element={<DynamicEventPage />} />

          <Route path="/inscrever-se/:slug" element={<GenericInscriptionPage />} />
          <Route path="/municipio/:slug" element={<MunicipalityPage />} />
          <Route path="/verificar-certificado/:code" element={<CertificateValidationPage />} />

          {/* Legacy Redirects */}
          <Route path="/cafe-2026" element={<Navigate to="/evento/cafe-2026" replace />} />
          <Route path="/pinhal-2026" element={<Navigate to="/evento/pinhal-2026" replace />} />
          <Route path="/tramandai-2026" element={<Navigate to="/evento/tramandai-2026" replace />} />

          <Route path="/inscricao-cafe" element={<Navigate to="/inscrever-se/cafe" replace />} />
          <Route path="/inscricao-pinhal" element={<Navigate to="/inscrever-se/pinhal" replace />} />
          <Route path="/inscricao-tramandai" element={<Navigate to="/inscrever-se/tramandai" replace />} />

          <Route path="/inscricao/:slug" element={<InscriptionRedirect />} />

          {/* Sub-routing groups */}
          <Route path="/organizador/*" element={<OrganizerRoutes />} />
          <Route path="/area-restrita/*" element={<RestrictRoutes />} />
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/app/*" element={<PwaRoutes />} />

          <Route path="*" element={<HomePage />} />
        </Routes>
      </ConfirmProvider>
    </Suspense>
  );
}

export default App;
